import styled from 'styled-components';
import Button from '../../button';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.darkBackground};
  color: ${({ theme }) => theme.palette.white};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.spacing.medium};
`;

export const Heading = styled.h2`
  font-size: ${({ theme }) => theme.fontsize.h3};
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

export const ButtonSpace = styled(Button)`
  text-decoration: none;
  margin-right: ${({ theme }) => theme.spacing.medium};
  margin-top: ${({ theme }) => theme.spacing.small};
  &:hover,
  &:active {
    text-decoration: none;
  }
`;
